import React, { memo } from 'react'

import moment from 'moment'

import { Avatar, Grid, makeStyles, Paper, Typography } from '@material-ui/core'
import TextMessage from './TextMessage/TextMessage'
import FileMessage from './FileMessage/FileMessage'

const usePaperStyle = makeStyles(theme => ({
  root: ({ isOwner }) => ({
    background: isOwner ? 'ghostwhite' : 'white',
    padding: theme.spacing(1)
  })
}))

const useGridStyle = makeStyles(theme => ({
  root: ({ isDraft }) => ({
    opacity: isDraft ? 0.7 : 1
  })
}))

const ChatMessage = ({ message, isOwner, sender, file, timestamp, isDraft, onFileClick }) => {
  const paperClasses = usePaperStyle({ isOwner })
  const gridClasses = useGridStyle({ isDraft })

  const { full_name: sentFrom, img_path: senderImgPath } = sender
  const sentMoment = moment(timestamp)

  const avatar = (
    <Grid item xs={3} sm={2} lg={1}>
      <Avatar src={senderImgPath} alt={sentFrom} />
    </Grid>
  )

  let justify = 'flex-start'
  let textAlign = 'left'
  let leftAvatar = avatar
  let rightAvatar = null

  if (isOwner) {
    justify = 'flex-end'
    textAlign = 'right'
    leftAvatar = null
    rightAvatar = avatar
  }

  const messageDisplay = <TextMessage message={message} justify={justify} />

  let fileDisplay = null
  if (file) {
    fileDisplay = <FileMessage file={file} onFileClick={onFileClick} />
  }

  return (
    <Grid container classes={gridClasses} justify={justify} alignItems={'flex-end'} spacing={3}>
      {leftAvatar}
      <Grid item xs={8} lg={9}>
        <Typography
          component={'div'}
          variant={'caption'}
          align={textAlign}
          style={{ width: '100%' }}>
          {sentFrom}, {sentMoment.calendar()}
        </Typography>
        <Paper classes={paperClasses}>
          {fileDisplay}
          {messageDisplay}
        </Paper>
      </Grid>
      {rightAvatar}
    </Grid>
  )
}

export default memo(ChatMessage)
